/* eslint-disable */

let players = $('.yt-player'),
    tag = null,
    firstScriptTag = null;

//get youtube video id
function YouTubeGetID(url) {
    let ID = '';
    url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if (url[2] !== undefined) {
        ID = url[2].split(/[^0-9a-z_\-]/i);
        ID = ID[0];
    } else {
        ID = url;
    }
    return ID;
}

if (players.length) {
    // 2. This code loads the IFrame Player API code asynchronously.
    tag = document.createElement('script');
    firstScriptTag = document.getElementsByTagName('script')[0];

    tag.src = 'https://www.youtube.com/iframe_api';
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // 3. This function creates an <iframe> (and YouTube player)
    //    after the API code downloads.
    window.onYouTubeIframeAPIReady = function () {
        let player_data = null,
            player_id = null,
            url = null,
            autoplay = null,
            wmode = null,
            videoid = null;

        players.each(function () {
            player_data;
            player_data = $(this);
            player_id = player_data.attr('id');
            url = player_data.data('url');
            autoplay = player_data.data('autoplay');
            wmode = player_data.data('wmode');
            videoid = YouTubeGetID(url);

            if (videoid != null) {
                console.log('video id = ', videoid);
            } else {
                console.log('The youtube url is not valid.');
            }
            new YT.Player(player_id, {
                height: '100%',
                width: '100%',
                playerVars: {autoplay: autoplay},
                wmode: wmode,
                videoId: videoid,
            });
        });
    };
}
